import React, { createContext, useContext, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { useCore } from 'hooks'
import DefaultEntity from 'app/Default'
import Redirect404 from 'components/Redirect404'
import { ALLOWED_CORBAN_SUBMODULES, TCorbanSubModule } from 'constants/corban'
import { CORBAN_SUBMODULES } from 'interfaces/submodules'

interface ICorbanContext {
  subModule: TCorbanSubModule
}

export function isCorbanSubModule(subModule: any): subModule is TCorbanSubModule {
  return ALLOWED_CORBAN_SUBMODULES.includes(subModule) || subModule === CORBAN_SUBMODULES.CONFIG
}

const CorbanContext = createContext<ICorbanContext | null>(null)

export const useCorbanContext = () => {
  const context = useContext(CorbanContext)
  if (!context) {
    throw new Error('useCorbanContext deve ser usado dentro de um CorbanProvider')
  }
  return context
}

export const CorbanProvider: React.FC = ({ children }) => {
  const {
    entity: { module },
  } = useCore()
  const history = useHistory()

  const subModule = module?.subModule

  if (!subModule) {
    history.push(DefaultEntity.route.PROFILES.path)
    return null
  }

  if (!isCorbanSubModule(subModule)) {
    console.error(`Submódulo inválido "${subModule}" para o fluxo de propostas.`)
    return <Redirect404 />
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const contextValue = useMemo(
    () => ({
      subModule,
    }),
    [subModule]
  )

  return <CorbanContext.Provider value={contextValue}>{children}</CorbanContext.Provider>
}
